<div class="outer w-100">
  <div class="subindex-content">
    <app-classified-top-videos [style.order]="0" [title]="'最近添加'" [showRandomVideos]="false" [link]="'/list/' +slug"
      [linkParams]="{ orderBy:0, desc:true }" [recommendedVideos]="recentAdded">
    </app-classified-top-videos>
    <app-release-schedule [category]="currentCategory" [subcategory]="genres"
      *ngIf="!!currentCategory&&currentCategory.cid!='0,1,3'&&currentCategory.cid!='0,1,7'"></app-release-schedule>

    <app-classified-top-videos [title]="'猜你喜欢'" [showRandomVideos]="false" [blockTitleAsLink]="false"
      [showRefreshButton]="true" [recommendedVideos]="guessYouLikeVideos" [contentLoading]="contentLoading"
      [blockTitleAsLink]="false" (refreshEvent)="refreshGuessYouLikeVideos()">
    </app-classified-top-videos>
  </div>

  
  <app-classified-top-videos *ngFor="let genre of genres" [title]="genre.title"
    [link]="'/list/' +slug +(genre.index?'-'+ genre.index:'')" [linkParams]="{region:genre.region}" [slug]="genre.slug"
    [cid]="genre.id +(genre.region?'_'+ genre.region:'')"
    [recommendedVideos]="dataList[genre.id +(genre.region?'_'+ genre.region:'') +'List']"
    >
  </app-classified-top-videos>

  <div style="padding-bottom: 30px;"></div>
</div>
<app-footer class="d-block"></app-footer>